/**
 * Leads Module Routes
 *
 * Route definitions for the Leads module.
 * All routes are relative to the module path (/leads).
 */

import type { RouteRecordRaw } from 'vue-router'
import ModuleLayout from '@/layouts/ModuleLayout.vue'

const routes: RouteRecordRaw[] = [
    {
        path: '/leads',
        component: ModuleLayout,
        meta: {
            moduleKey: 'leads',
        },
        children: [
            {
                path: '',
                name: 'leads-list',
                component: () => import('./views/LeadList.vue'),
                meta: {
                    title: 'All Leads',
                },
            },
            {
                path: 'create',
                name: 'leads-create',
                component: () => import('./views/LeadCreate.vue'),
                meta: {
                    title: 'New Lead',
                    moduleKey: 'leads',
                    minAccessLevel: 'standard',
                },
            },
            {
                path: ':id',
                name: 'leads-detail',
                component: () => import('./views/LeadDetail.vue'),
                meta: {
                    title: 'Lead Details',
                },
            },
        ],
    },
]

export default routes
